var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"company-not-paid"}},[_c('span',{staticClass:"heading"},[_vm._v("This company account has been temporarily deactivated.")]),_c('p',[_vm._v("Please contact the account administrator for further assistance.")])])
}]

export { render, staticRenderFns }